export default __webpack_public_path__ + "static/media/zvatiko.0b60dded.png";